/** Click-to-seek ratio on a waveform or progress bar. */
export function seekRatioFromClientX(clientX, rect) {
  const width = rect?.width || 0;
  if (!width || !Number.isFinite(clientX)) return null;
  return Math.max(0, Math.min(1, (clientX - rect.left) / width));
}
